import React from 'react'
import { getActionIcon } from './utils/get-action-icon'
import { getAutomationRuleActionIdAndLabel } from './utils/get-automation-rule-action-id-and-label'
import { ActionSaveType } from 'src/editor/shared/types/automation-rules/actions-types'
import { Dotpoints01Icon } from 'src/editor/shared/icons/dotpoints-01-icon'
import { SettingsMenuButtonWithIconAndBorder } from '../../components/settings-menu-buttons/settings-menu-button-with-icon-and-border'
import { useTranslation } from 'react-i18next'
import { automationRuleActionsTitlesLocaleKeys } from './constants/loco-keys'

interface EditedActionsPreviewProps {
  actions: ActionSaveType[]
  onOpenEditAction: (id: number) => void
  onOpenFullEditedActionsList: () => void
}

export const EditedActionsPreview = ({
  actions,
  onOpenEditAction,
  onOpenFullEditedActionsList,
}: EditedActionsPreviewProps) => {
  const { t } = useTranslation()
  return (
    <>
      {actions.length <= 2 ? (
        actions.map(action => {
          const { label } = getAutomationRuleActionIdAndLabel(action)
          return (
            <SettingsMenuButtonWithIconAndBorder
              key={action.id}
              title={automationRuleActionsTitlesLocaleKeys[action.type]}
              subtitle={label}
              iconBefore={() => getActionIcon(action.type)}
              onClick={() => {
                onOpenEditAction(action.id as number)
              }}
            />
          )
        })
      ) : (
        <SettingsMenuButtonWithIconAndBorder
          title={
            'entity_settings.automation_rules_settings.preview.see_all.title'
          }
          subtitle={t(
            'entity_settings.automation_rules_settings.preview.see_all.count_icu',
            { count: actions.length },
          )}
          iconBefore={() => <Dotpoints01Icon />}
          onClick={onOpenFullEditedActionsList}
        />
      )}
    </>
  )
}
